/* EXTERNAL LINKS */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* SLIDING LINKS */

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const offset = 80;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  });
});

/* READ FULL DESC */
document.querySelector('a.read-more[href="#full-description"]').addEventListener('click', function(e) {
  e.preventDefault();
  
  const accordion = document.querySelector('accordion-group#full-description');
  if (!accordion) return;

  // Try common trigger patterns inside the accordion
  const trigger = accordion.querySelector('button, [role="button"], .accordion-trigger, summary');
  
  if (trigger) {
    trigger.click();
  } else {
    // Fallback: dispatch a click on the accordion element itself
    accordion.click();
  }
});


/* HIDE ADD TO CART BUTTON IF VOLUME DISCOUNT IS AVAILABLE */
const observer = new MutationObserver(() => {
  if (document.querySelector('.zrx-vd-add-to-cart-button')) {
    document.querySelectorAll([
      '.product-form__add-btn.c-btn--primary',
      '.product-single__box__block.product-single__box__block--buy_buttons',
      '.product-single__box__block.product-single__box__block--quantity_selector'
    ].join(',')).forEach(el => {
      el.style.display = 'none';
    });
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });
